import { render, staticRenderFns } from "./atualizarStatus.vue?vue&type=template&id=32f3b773"
import script from "./atualizarStatus.ts?vue&type=script&lang=js&external"
export * from "./atualizarStatus.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32f3b773')) {
      api.createRecord('32f3b773', component.options)
    } else {
      api.reload('32f3b773', component.options)
    }
    module.hot.accept("./atualizarStatus.vue?vue&type=template&id=32f3b773", function () {
      api.rerender('32f3b773', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/produtolote/atualizarStatus.vue"
export default component.exports